import React, { useState, useEffect } from 'react'
import { connectStore } from 'redux-box'
import { ThemeButton } from '../../../../static/styled/custom.styled'
import './unlink.css'
import { module as ui } from "@st/ui";
import { module as user } from "@st/user";
import Select from 'react-select'

const UnlinkSchoolCode = (props) => {
  const [sections, setSections] = useState([])
  const [linkedSections, setLinkedSections] = useState([])

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      position: "relative"
    }),
  };

  useEffect(() => {
    if (props.user.active_child && props.user.active_child.school_class) {
      const activeClasses = Array.isArray(props.user.active_child.school_class)
        ? props.user.active_child.school_class
        : [props.user.active_child.school_class];

      let allSections = activeClasses.map((section) => ({
        value: section.id,
        label: section.name
      }));

      setLinkedSections(allSections);
    }
  }, [props.user.active_child])

  const handleUnlinkSchool = (unlinkAll = false) => {
    const { user } = props;
    let data = {};
    if (props.user.active_child && props.user.active_child.is_teacher) {
      data = {
        school: user.active_child.school_code,
        child: user.active_child.id,
        school_class: unlinkAll ? [] : sections.map((sec) => sec.value),
        showMessage: true
      };
    } else {
      data = {
        school: user.active_child.school_code,
        child: user.active_child.id,
        showMessage: true
      };
    }

    user.unlinkSchoolCode(data);
    props.ui.hideModal();
  }

  return (
    <div className='unlink_school_code_modal'>
      <p>Are you sure you want to unlink the school from this profile?</p>
      {
        props.user.active_child && props.user.active_child.is_teacher && linkedSections.length > 0 &&
        <Select
          className="dropdown-container"
          isMulti={true}
          value={sections}
          onChange={(selectedSection) => setSections(selectedSection || [])}
          options={linkedSections}
          placeholder="Select Section(s) to Unlink"
          styles={customStyles}
        />
      }
      <div className='unlink_btn_container' style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
        <ThemeButton onClick={() => handleUnlinkSchool(false)} primary style={{ flex: 1 }}>UnLink</ThemeButton>
        {
          props.user.active_child && props.user.active_child.is_teacher && linkedSections.length > 0 && sections.length === 0 &&
          <ThemeButton onClick={() => handleUnlinkSchool(true)} primary style={{ flex: 1 }}>UnLink All</ThemeButton>
        }
        <ThemeButton onClick={() => props.ui.hideModal()} style={{ flex: 1 }}>Cancel</ThemeButton>
      </div>
    </div>
  )
}

export default connectStore({
  ui, user
})(UnlinkSchoolCode)